import { useQuery } from "@apollo/client/react";

import { GET_ORIGIN_INTEGRATION } from "./gql";

const useGetOriginIntegration = () => {
  const { data, loading, error } = useQuery(GET_ORIGIN_INTEGRATION, {
    fetchPolicy: "no-cache",
  });

  return {
    integration: data?.originIntegration,
    isPageLoading: loading && !data?.originIntegration,
    error,
  };
};

export default useGetOriginIntegration;
